import React from "react";
// styled components
// style
import "../Jurados.style.scss";

// model
interface IProps {
  numero: string;
  textosinspan: string;
  textospan: string;
  color: string;
}

export const TextoinicialNumero: React.FC<IProps> = (props: IProps) => {
  return (
 
	<div className="col-12 mt-4 mb-2">
         <div className="row">
      <div
        className={`col-1 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion background-titulos-jurados-${props.color}`}
      >
        {props.numero}
      </div>
      <div className="col ps-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
        {props.textosinspan} - <span className="font-size-10px font-color-DB2828">{props.textospan}</span>
      </div>
    </div>
      </div>

	  
    
  );
};